module.exports = __webpack_public_path__ + "img/michelle.9be29c71.jpg";